import { Injectable } from '@angular/core';
import { Action } from '../components/widgets/smart-table/actions/action';

@Injectable({
  providedIn: 'root'
})
export class ActionHandlerService {

  private actionHandlers: { [operation: string]: Action } = {};

  register(operation: string, action: Action): void {
    this.actionHandlers[operation] = action;
  }

  execute(row: any, val: any): void {
    const operation = row.type;
    const actionHandler = this.actionHandlers[operation];
    if (actionHandler)
      actionHandler.execute(val, row);
    else
      console.warn("Operation doesn't not exists: ", operation);
  }


}
